// extracted by mini-css-extract-plugin
export default {"strategyContent":"Strategy_strategyContent__jVfqy","leftSection":"Strategy_leftSection__Wn6-g","rightSection":"Strategy_rightSection__aeC3L","night":"Strategy_night__UtgeU"};